export default __webpack_public_path__ + "static/media/bubbleTea.4756a7ae.webp";